import React from "react";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import logo from "../../Images/assetLogoWithtext.png";
import { toast } from "react-toastify";
import { loginApi } from "../../services/AuthService";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import { BiLogoGmail } from "react-icons/bi";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
const AuthLogin1 = () => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPwd, setShowPwd] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    emailRef.current?.focus();
  }, []);
  const handleKeyDownEmail = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!email) {
        setErrors((prev) => ({ ...prev, email: "Email is required" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
        passwordRef.current?.focus();
      }
    }
  };

  const handleKeyDownPassword = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!password) {
        setErrors((prev) => ({ ...prev, password: "Password is required" }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
        onLogin(e);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") setEmail(value);
    if (name === "password") setPassword(value);
    setErrors({ ...errors, [name]: "" });
  };
  const onLogin = async (e) => {
    e.preventDefault();
    if (!loading) {
      let error = false;
      const errorObj = { ...errors };

      if (!email) {
        errorObj.email = "Email is required";
        error = true;
      }
      if (!password) {
        errorObj.password = "Password is required";
        error = true;
      }

      setErrors(errorObj);

      if (error) return;

      try {
        setLoading(true);
        const formData = { email, password };
        const resp = await loginApi(formData);
        const { data, token } = resp.data;

        dispatch(loginConfirmedAction(data));
        navigate("/dashboard");

        if (process.env.REACT_APP_HEADER_TOKEN === "LOCALSTORAGE") {
          localStorage.setItem("TOKEN", token);
        }
      } catch (error) {
        if (error?.response?.data) {
          toast.error(error?.response?.data?.message);
        }
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <div className="loginpage">
      <div className="loginform">
        <div className="w-100 px-4 py-5 card rounded-3">
          <div>
            <div className="mb-2 text-center">
              <img
                src={logo}
                alt="Logo"
                style={{ height: "60px", width: "220px" }}
              />
            </div>
            <p
              className="text-primary mb-3 fw-semibold text-center"
              style={{ fontSize: "1.2rem", letterSpacing: "1px" }}
            >
              Login Your Account.
            </p>
            <div className="mb-2">
              <label className="form-label">
                Email
              </label>
              <div className="position-relative">
                <input
                  type="email"
                  ref={emailRef}
                  onChange={handleInputChange}
                  value={email}
                  name="email"
                  placeholder="Enter Email"
                  className={`form-control px-5 ${
                    errors?.email ? "is-invalid" : ""
                  }`}
                  onKeyDown={handleKeyDownEmail}
                />
                <FaUser
                  className="position-absolute top-50 translate-middle-y text-primary"
                  style={{ left: "15px", pointerEvents: "none" }}
                />
              </div>
            </div>
            <div className="mb-5">
              <label className="form-label">
                Password
              </label>

              <div className="position-relative">
                <input
                  ref={passwordRef}
                  type={showPwd ? "text" : "password"}
                  placeholder="Enter Password"
                  name="password"
                  className={`form-control px-5 ${
                    errors?.password ? "is-invalid" : ""
                  }`}
                  value={password}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDownPassword}
                />
                {/* Lock Icon (left) */}
                <FaLock
                  className="position-absolute top-50 translate-middle-y text-primary"
                  style={{ left: "15px", pointerEvents: "none" }}
                />
                {/* Toggle Eye Icon (right) */}
                <div
                  className="position-absolute top-50 translate-middle-y"
                  style={{ right: "15px", cursor: "pointer" }}
                  onClick={() => setShowPwd((prev) => !prev)}
                >
                  {!errors.password &&
                    (showPwd ? (
                      <FaEye className="text-primary" />
                    ) : (
                      <FaEyeSlash className="text-primary" />
                    ))}
                </div>
              </div>
            </div>
            
            <button
              className="btn btn-primary w-100 fw-semibold mb-3"
              disabled={loading}
              onClick={onLogin}
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Login"
              )}
            </button>
            {/* <div className="mt-4 d-flex align-items-center w-100 gap-2">
              <div className="border flex-fill" />
              <span className="text-dark fw-bold fs-6">Or sign with</span>
              <div className="border flex-fill" />
            </div>
            <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
              <button
                className="btn rounded-2 btn-outline-light text-info"
                style={{ padding: "0.4rem 0.5rem" }}
              >
                <FaFacebook size={21} />
              </button>
              <button
                className="btn btn-outline-light rounded-2"
                style={{ padding: "0.4rem 0.5rem" }}
              >
                <FcGoogle size={21} />
              </button>
              <button
                className="btn btn-outline-light rounded-2 text-danger"
                style={{ padding: "0.4rem 0.5rem" }}
              >
                <BiLogoGmail size={21} />
              </button>
            </div> */}
            {/* <div className="d-flex justify-content-center align-items-center gap-1 mt-3">
              <span className="text-primary">Don’t have an account? </span>
              <button
                className="btn btn-link p-0"
                // onClick={() => navigate("/register")}
              >
                Register here
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLogin1;
